export default __webpack_public_path__ + "static/media/Microsoft Edge Mobile.c3019f3c.svg";